export default __webpack_public_path__ + "static/media/security-awarness.40337003.png";